import gql from 'graphql-tag';

const GET_BASIC_TAG_ACTIVITY = gql`
  query getBasicTagActivity($appId: String!, $orgId: String, $tagId: String, $retailID: String) {
    getBasicTagActivity(appId: $appId, orgId: $orgId, tagId: $tagId, retailID: $retailID)
  }
`;

export default GET_BASIC_TAG_ACTIVITY;
